import React, { useContext } from 'react'
import { Language, DEFAULT_LANGUAGE } from '~/utils/language'

const LanguageContext = React.createContext<Language>(DEFAULT_LANGUAGE)

export function useLanguage() {
  return useContext(LanguageContext)
}

export default LanguageContext
